/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeDetails
 */
export interface StripeDetails {
    /**
     * Stripe customer ID associated with this user
     * @type {string}
     * @memberof StripeDetails
     */
    customerId?: string;
    /**
     * Default billing currency for this user (ISO 4217 lowercase)
     * @type {string}
     * @memberof StripeDetails
     */
    currency?: string;
}

/**
 * Check if a given object implements the StripeDetails interface.
 */
export function instanceOfStripeDetails(value: object): value is StripeDetails {
    return true;
}

export function StripeDetailsFromJSON(json: any): StripeDetails {
    return StripeDetailsFromJSONTyped(json, false);
}

export function StripeDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function StripeDetailsToJSON(json: any): StripeDetails {
    return StripeDetailsToJSONTyped(json, false);
}

export function StripeDetailsToJSONTyped(value?: StripeDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerId': value['customerId'],
        'currency': value['currency'],
    };
}

